import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

export const PasswordValidation: TextInputValidationFn = (value) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
  return {
    errorMessage: 'common:TRENDHIMCLUB_PASSWORD_REQUIREMENTS',
    success: typeof value === 'string' && regex.test(value),
  }
}

